function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M372.401,213.437l-51.236-39.375c0.102-0.49,0.16-0.996,0.16-1.516v-68.094c0-4.143-3.357-7.5-7.5-7.5h-46.658 c-4.143,0-7.5,3.357-7.5,7.5v22.348L202.55,82.908c-2.695-2.07-6.445-2.07-9.141,0L23.556,213.437 c-2.547,1.957-3.564,5.318-2.531,8.359c1.034,3.041,3.89,5.088,7.102,5.088h46.508v136.793c0,17.799,14.481,32.279,32.281,32.279 h182.129c17.8,0,32.281-14.48,32.281-32.279V226.885h46.506c3.212,0,6.067-2.045,7.102-5.088 C375.966,218.756,374.948,215.395,372.401,213.437z M274.667,111.953h31.658v50.705l-31.658-24.33V111.953z M306.325,363.678 c0,9.527-7.752,17.279-17.281,17.279H106.915c-9.529,0-17.281-7.752-17.281-17.279V223.111l108.346-82.107l108.346,82.107V363.678 z M316.346,211.885L202.51,125.617c-2.68-2.029-6.381-2.029-9.061,0L79.613,211.885H50.194L197.98,98.314l147.784,113.57H316.346z "
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.107,219.982c-19.508,0-36.751,14.191-41.933,34.512c-2.735,10.727-3.294,27.822,9.579,48.352 c11.642,18.564,31.702,35.701,59.624,50.934c1.119,0.609,2.355,0.916,3.592,0.916s2.472-0.307,3.591-0.916 c27.93-15.232,47.996-32.369,59.642-50.932c12.879-20.531,12.322-37.625,9.588-48.352c-5.182-20.322-22.43-34.514-41.944-34.514 c-11.743,0-22.428,5.086-30.874,14.525C189.528,225.068,178.848,219.982,167.107,219.982z M256.255,258.201 c2.509,9.842,5.534,44.309-58.285,80.414c-63.8-36.104-60.77-70.572-58.261-80.414c3.432-13.455,14.954-23.219,27.398-23.219 c9.508,0,18.189,5.689,24.447,16.021c1.358,2.244,3.791,3.615,6.414,3.615h0.001c2.623,0,5.055-1.369,6.414-3.613 c6.263-10.334,14.949-16.023,24.462-16.023C241.297,234.982,252.824,244.748,256.255,258.201z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M286.899,81.34c1.119,0.611,2.355,0.916,3.592,0.916c1.236,0,2.472-0.305,3.591-0.916 c16.191-8.83,27.872-18.84,34.718-29.752c7.854-12.52,7.482-23.074,5.787-29.723C331.305,8.992,320.305,0,307.838,0 c-6.37,0-12.378,2.42-17.346,6.844C285.527,2.42,279.522,0,273.152,0c-12.463,0-23.46,8.99-26.743,21.863 c-1.695,6.65-2.068,17.203,5.782,29.723C259.034,62.5,270.712,72.51,286.899,81.34z M260.944,25.57 c1.561-6.125,6.696-10.57,12.208-10.57c4.207,0,7.984,2.564,10.924,7.418c1.358,2.244,3.791,3.615,6.414,3.615h0.001 c2.622,0,5.055-1.371,6.414-3.613c2.941-4.854,6.722-7.42,10.933-7.42c5.516,0,10.652,4.445,12.214,10.57 c2.538,9.957-4.045,25.629-29.56,40.572C264.984,51.201,258.405,35.527,260.944,25.57z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 395.957 395.957",
    style: {
      fill: "#f8c0c4"
    },
    xmlSpace: "preserve",
    width: "100px",
    height: "100px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house.d88e6f76.svg";
export { ForwardRef as ReactComponent };